export default "__VITE_ASSET__0c97b3de__"